/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_Style_NameInputs */

const en_col_style_name = /** @type {(inputs: Col_Style_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style name`)
};

/**
* | output |
* | --- |
* | "Style name" |
*
* @param {Col_Style_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const col_style_name = /** @type {((inputs?: Col_Style_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_Style_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_col_style_name(inputs)
});